import { TableBodyCell, TableCellEmpty } from '@pocketlaw/tetris';
export function EmptyCell(props) {
    return (<TableBodyCell {...props}>
      <TableCellEmpty />
    </TableBodyCell>);
}
